import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IContinuousRoute } from '$/types'
import { ILocalFilter, RiskUnitType } from '.'

interface ILocalFilterSliceState {
  riskUnit: RiskUnitType
  savedFilter: ILocalFilter
  showRiskDensity: boolean
  /**
   * Used for resetting local filter when going from line view to system view
   */
  previousLineId?: string
  previousSegments?: IContinuousRoute[]
}

const initialState: ILocalFilterSliceState = {
  riskUnit: RiskUnitType.TotalRisk,
  showRiskDensity: false,
  previousSegments: [],
  previousLineId: '',
  savedFilter: {
    id: 0,
    name: '',
    segments: [],
    hmca: [],
    classLocations: [],
    riskLevels: []
  }
}

export const localFilterSlice = createSlice({
  name: 'localFilters',
  initialState,
  reducers: {
    setRiskUnit: (state, action: PayloadAction<RiskUnitType>) => {
      state.riskUnit = action.payload
    },
    setShowRiskDensity: (state, action: PayloadAction<boolean>) => {
      state.showRiskDensity = action.payload

      if (!state.showRiskDensity) {
        state.riskUnit = RiskUnitType.TotalRisk
      }
    },
    setSavedFilter: (state, action: PayloadAction<ILocalFilter>) => {
      state.savedFilter = action.payload

      state.savedFilter.segments.forEach((route) => {
        return {
          id: route.id,
          continuousRouteId: route.id,
          name: route.name,
          fromMeasure: route.fromMeasure,
          toMeasure: route.toMeasure,
          initialFromMeasure: route.initialFromMeasure,
          initialToMeasure: route.initialToMeasure
        }
      })
    },
    setPreviousSegments: (state, action: PayloadAction<IContinuousRoute[]>) => {
      state.previousSegments = action.payload
    },
    setPreviousLineId: (state, action: PayloadAction<string>) => {
      state.previousLineId = action.payload
    }
  }
})

export const {
  setRiskUnit: setRiskUnitSync,
  setSavedFilter: setSavedFilterSync,
  setPreviousSegments: setPreviousSegmentsSync,
  setPreviousLineId: setPreviousLineIdSync,
  setShowRiskDensity: setShowRiskDensitySync
} = localFilterSlice.actions

export default localFilterSlice.reducer
